<template>
    <tw-card title="My Scores" class="transition duration-500 ease-in-out dark:text-white items-center" height="dark:bg-gray-900" :center-text="true">
        <template #filter>
            <div class="col-span-1">
                <jet-date-picker id="date" as-single v-model="dateModel" placeholder="Select Date" :formatter="format"  />
            </div>
        </template>

        <score v-if="scores.length" v-for="score in scores" :score="score" />

        <div class="flex p-4 sm:p-0" v-else>
            No scores for the chosen date selection.
        </div>
    </tw-card>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import JetDatePicker from '@/Jetstream/DatePicker.vue'

export default {
    components: {
        TwCard,
        JetDatePicker,
    },

    setup(props) {
        const scores = ref({})

        const dateModel = ref(new Date().toLocaleDateString('en-GB'))

        const format = ref({
            date: 'DD/MM/YYYY',
            month: 'MMM'
        })

        const getScores = () => {
            axios.get(route('api.scores.index'), {
                params: {
                    date: dateModel.value
                }
            }).then(response => {
                scores.value = response.data
            })
        }

        onMounted(() => {
            getScores()

            Echo.channel('results')
                .listen('RaceResultsUpdated', (e) => {
                    getScores()
                })
        })

        watch(dateModel, (currentValue, oldValue) => {
            getScores()
        })

        return {
            dateModel,
            format,
            scores,
        }
    }
}

</script>